import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BackendResponse, DateService, HttpService, Logger, LoggingService, ToastrService } from 'vas-mobile-api';

import { Delivery } from '../models/delivery';

@Component({
  selector: 'app-loading-slot-popup',
  templateUrl: './loading-slot-popup.component.html',
  styleUrls: ['./loading-slot-popup.component.css']
})
export class LoadingSlotPopupComponent implements OnInit, OnDestroy {

  private logger: Logger;
  public slots: string[] = [];
  public dateToday = new Date();
  public slotFormGroup: FormGroup;
  private ngUnsubscribe = new Subject();
  private artikelNr: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { delivery: Delivery },
    public dialogRef: MatDialogRef<LoadingSlotPopupComponent>,
    private formBuilder: FormBuilder,
    private httpService: HttpService,
    private loggingService: LoggingService,
    private dateService: DateService,
    private toastService: ToastrService) {
    this.logger = this.loggingService.getLogger(LoadingSlotPopupComponent.name);
  }

  ngOnInit() {

    this.artikelNr = this.data.delivery.positions[0].ARTIKEL_NR;

    this.slotFormGroup = this.formBuilder.group({
      slotDateCtrl: [new Date(this.data.delivery.loadingSlot.SLOTVON_DATE).toISOString().substring(0, 10), Validators.required],
      slotTimeCtrl: ['', Validators.required]
    });

    this.loadSlots(new Date(this.data.delivery.loadingSlot.SLOTVON_DATE));

    this.slotFormGroup.get('slotDateCtrl').valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((date: Date) => {
      this.loadSlots(date);
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private loadSlots(date: Date) {

    const dateNow = new Date();

    let isToday = false;
    if (date.toLocaleDateString() === dateNow.toLocaleDateString()) {
      isToday = true;
    }

    const slotDate: string = this.dateService.getDate(date);
    this.logger.debug('Loading slots for', slotDate);
    if (slotDate) {
      this.httpService.get<BackendResponse<string[]>>({
        pathId: 'getEmptySlotsForProduct', urlParams: {
          date: slotDate,
          productID: this.artikelNr
        }
      }).subscribe((result) => {

        if (isToday) {
          // slot: ["06:00 - 06:30",...]
          this.slots = result.data.filter((slot) => slot.split('-')[0].trim().localeCompare(dateNow.getHours() + ':' + dateNow.getMinutes()) > -1);
        } else {
          this.slots = result.data;
        }

      });
    }

  }

  public onSave() {

    this.httpService.get<BackendResponse<any>>({
      pathId: 'changeSlotForDelivery',
      urlParams: {
        liefer_nr: this.data.delivery.LIEFER_NR,
        date: this.dateService.getDate(this.slotFormGroup.get('slotDateCtrl').value),
        time: this.slotFormGroup.get('slotTimeCtrl').value,
        emailNotification: false
      }
    }).subscribe(() => {
      this.toastService.success('Slot successfully changed');
      this.dialogRef.close();
    });

  }

}
